import { GameAnswers } from "./game-answers.model";
import { Guess } from "./guess.model";

export class GameState {
    username: string;
    spinning: boolean;
    hiddenAreas: Array<number>;
    playDate: string;
    guesses: Array<Guess>;
    isEnded: boolean;
    isWinner: boolean;
    answers: GameAnswers;

    constructor(username: string) {
        this.username = username;
        this.spinning = true;
        this.hiddenAreas = [0, 1, 2, 3, 4, 5, 6, 7, 8];
        this.guesses = [];
        this.playDate = new Date().toDateString();
        this.isEnded = false;
        this.isWinner = false;
        this.answers = new GameAnswers();
    }

    setAnswers(answers: GameAnswers) {
        this.answers = answers;
        this.isEnded = answers.hasPlayed;
        this.isWinner = answers.points > 0;
    }
}